import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({
  isOpen,
  onCancel,
  onConfirm,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  showCancel = true,
  isDanger = false,
}) => {
    React.useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape' && onCancel) onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && onCancel) {
      onCancel();
    }
  };

  return (
    <div className="confirmation-modal-backdrop" onClick={handleBackdropClick} role="presentation">
      <div className="confirmation-modal-content" role="dialog" data-testid="confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirmation-modal-message">{message}</div>
        <div className="confirmation-modal-actions">
          {showCancel && (
            <button
              className="confirmation-modal-button cancel"
              onClick={onCancel}
            >
              {cancelLabel}
            </button>
          )}
          <button
            className={`confirmation-modal-button confirm ${isDanger ? 'danger' : ''}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
